export default __webpack_public_path__ + "static/media/about.ede24990.jpg";